/**
 * Safe wrappers around localStorage / sessionStorage.
 *
 * Safari **Private Browsing** throws `QuotaExceededError` on EVERY
 * `localStorage.setItem` call — unprotected calls at module scope or during
 * render will crash the entire React tree and leave the user with a blank
 * white screen. These helpers never throw.
 */

const safeWindow = typeof window !== "undefined" ? window : null;

function get(storage) {
  try {
    return safeWindow ? safeWindow[storage] : null;
  } catch {
    return null;
  }
}

export const safeStorage = {
  getItem(key) {
    try {
      const s = get("localStorage");
      return s ? s.getItem(key) : null;
    } catch {
      return null;
    }
  },
  setItem(key, value) {
    try {
      const s = get("localStorage");
      if (s) s.setItem(key, value);
    } catch {
      /* Safari private / full quota — silently ignore */
    }
  },
  removeItem(key) {
    try {
      const s = get("localStorage");
      if (s) s.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};

export default safeStorage;
